"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_IN_ROOM_STATUS = exports.ROOM_TYPE = exports.ROOM_TRANSFER_TYPES = exports.ROOM_DISPLAY_MODE = void 0;
var ROOM_DISPLAY_MODE = exports.ROOM_DISPLAY_MODE = {
  FULL_SCREEN: 'fullscreen',
  GRID: 'grid'
};
var ROOM_TRANSFER_TYPES = exports.ROOM_TRANSFER_TYPES = {
  ALL: 'all'
};
var ROOM_TYPE = exports.ROOM_TYPE = {
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO'
};
var USER_IN_ROOM_STATUS = exports.USER_IN_ROOM_STATUS = {
  WAITING: 0,
  JOINED: 1,
  LEFT: 2,
  KICKED: 3,
  MISSED: 4,
  HOLD: 5
};